import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = "https://danielcantos.net/api";

function SourceBadge({ source }) {
  if (source === "web") {
    return (
      <span style={{fontSize:"11px",padding:"2px 8px",borderRadius:"12px",background:"#e0f2fe",color:"#0369a1",fontWeight:600}}>
        🌐 Internet
      </span>
    );
  }
  if (source === "documents") {
    return (
      <span style={{fontSize:"11px",padding:"2px 8px",borderRadius:"12px",background:"#dcfce7",color:"#15803d",fontWeight:600}}>
        📁 Documentos internos
      </span>
    );
  }
  return null;
}

export default function KnowledgeBase() {
  const [sessions, setSessions] = useState([]);
  const [currentSession, setCurrentSession] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [syncMsg, setSyncMsg] = useState("");
  const [searchWeb, setSearchWeb] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [activeTab, setActiveTab] = useState("chat");
  const [uploading, setUploading] = useState(false);
  const [category, setCategory] = useState("general");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const saved = localStorage.getItem("kb_messages");
    const savedSession = localStorage.getItem("kb_session_id");
    if (saved) setMessages(JSON.parse(saved));
    if (savedSession) setCurrentSession(savedSession);
    loadSessions();
    loadDocuments();
  }, []);

  useEffect(() => {
    localStorage.setItem("kb_messages", JSON.stringify(messages));
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const loadSessions = async () => {
    try {
      const res = await axios.get(`${API}/knowledge/chat-sessions`);
      setSessions(res.data || []);
    } catch {}
  };

  const loadDocuments = async () => {
    try {
      const res = await axios.get(`${API}/knowledge/documents`);
      setDocuments(res.data || []);
    } catch {}
  };

  const openSession = async (session) => {
    try {
      const res = await axios.get(`${API}/knowledge/chat-history/${session.session_id}`);
      const hist = res.data?.messages || [];
      setMessages(hist.map(m => ({ role: m.role, content: m.content, source: "documents" })));
      setCurrentSession(session.session_id);
      localStorage.setItem("kb_session_id", session.session_id);
    } catch {
      alert("No se pudo cargar la sesión.");
    }
  };

  const newChat = () => {
    setMessages([]);
    setCurrentSession(null);
    localStorage.removeItem("kb_messages");
    localStorage.removeItem("kb_session_id");
  };

  const sendMessage = async () => {
    const text = input.trim();
    if (!text || loading) return;
    setMessages(prev => [...prev, { role: "user", content: text, source: null }]);
    setInput("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/knowledge/chat`, {
        message: text,
        session_id: currentSession,
        search_web: searchWeb,
      });
      const { response, session_id, source } = res.data;
      if (!currentSession) {
        setCurrentSession(session_id);
        localStorage.setItem("kb_session_id", session_id);
      }
      setMessages(prev => [...prev, { role: "assistant", content: response, source }]);
      loadSessions();
    } catch (err) {
      const errMsg = err.response?.data?.detail || "Error al conectar con el servidor.";
      setMessages(prev => [...prev, { role: "assistant", content: `❌ Error: ${errMsg}`, source: null }]);
    } finally {
      setLoading(false);
    }
  };


  const deleteSession = async (e, session) => {
    e.stopPropagation();
    try {
      await axios.delete(`${API}/knowledge/chat-sessions/${session.session_id}`);
      if (currentSession === session.session_id) newChat();
      loadSessions();
    } catch { alert('No se pudo eliminar.'); }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      form.append("category", category);
      await axios.post(`${API}/knowledge/upload`, form);
      loadDocuments();
      alert(`✅ "${file.name}" cargado correctamente.`);
    } catch (err) {
      alert(`❌ Error: ${err.response?.data?.detail || "No se pudo subir el archivo."}`);
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const handleDelete = async (filename) => {
    if (!window.confirm(`¿Eliminar "${filename}"?`)) return;
    try {
      await axios.delete(`${API}/knowledge/documents/${encodeURIComponent(filename)}`);
      loadDocuments();
    } catch {
      alert("No se pudo eliminar el documento.");
    }
  };

  return (
    <div style={{display:"flex",height:"calc(100vh - 60px)",fontFamily:"sans-serif"}}>
      <div style={{width:"240px",minWidth:"200px",background:"#1e293b",color:"#e2e8f0",display:"flex",flexDirection:"column",borderRight:"1px solid #334155"}}>
        <div style={{padding:"12px 10px",borderBottom:"1px solid #334155"}}>
          <button onClick={newChat} style={{width:"100%",padding:"8px",background:"#3b82f6",color:"white",border:"none",borderRadius:"6px",cursor:"pointer",fontWeight:600}}>
            + Nueva conversación
          </button>
        </div>
        <div style={{overflowY:"auto",flex:1}}>
          {sessions.map(s => (
            <div key={s.session_id} onClick={() => openSession(s)} style={{padding:"10px 12px",cursor:"pointer",fontSize:"13px",borderBottom:"1px solid #334155",background:currentSession===s.session_id?"#334155":"transparent"}}>
              <div style={{fontWeight:500,color:"#f1f5f9",marginBottom:"3px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.title||"Conversación"}</div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{fontSize:"11px",color:"#94a3b8"}}>{new Date(s.timestamp).toLocaleDateString("es-EC")} · {s.messages} msg</span><button onClick={(e)=>deleteSession(e,s)} style={{background:"transparent",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:"14px",padding:"0 2px"}} title="Eliminar">✕</button></div>
            </div>
          ))}
        </div>
      </div>

      <div style={{flex:1,display:"flex",flexDirection:"column",background:"#f8fafc"}}>
        <div style={{display:"flex",borderBottom:"1px solid #e2e8f0",background:"white",padding:"0 16px"}}>
          {["chat","docs"].map(tab => (
            <button key={tab} onClick={() => setActiveTab(tab)} style={{padding:"12px 18px",border:"none",background:"transparent",cursor:"pointer",fontWeight:activeTab===tab?700:400,borderBottom:activeTab===tab?"2px solid #3b82f6":"2px solid transparent",color:activeTab===tab?"#3b82f6":"#64748b"}}>
              {tab==="chat"?"💬 Chat":"📁 Documentos"}
            </button>
          ))}
          <button onClick={async()=>{setSyncing(true);try{const r=await axios.post(API+"/knowledge/sync");setSyncMsg("✅ "+r.data.processed+" procesados");loadDocuments();}catch(e){setSyncMsg("❌ Error");}setSyncing(false);}} disabled={syncing} style={{marginLeft:"auto",padding:"8px 14px",border:"none",background:"#10B981",color:"white",cursor:"pointer",fontWeight:600,fontSize:"12px",borderRadius:"6px",opacity:syncing?0.6:1}}>{syncing?"⏳...":"🔄 Sincronizar"}</button>
        </div>

        {activeTab==="chat" && (
          <div style={{flex:1,display:"flex",flexDirection:"column"}}>
            <div style={{flex:1,overflowY:"auto",padding:"20px"}}>
              {messages.length===0 && (
                <div style={{textAlign:"center",color:"#94a3b8",marginTop:"60px"}}>
                  <div style={{fontSize:"40px",marginBottom:"12px"}}>🧠</div>
                  <div style={{fontSize:"16px",fontWeight:600}}>Base de Conocimiento</div>
                  <div style={{fontSize:"13px",marginTop:"6px"}}>Pregunta sobre tus documentos, contratos, fichas técnicas o proyectos.</div>
                </div>
              )}
              {messages.map((msg,i) => (
                <div key={i} style={{marginBottom:"16px",display:"flex",justifyContent:msg.role==="user"?"flex-end":"flex-start"}}>
                  <div style={{maxWidth:"72%",background:msg.role==="user"?"#3b82f6":"white",color:msg.role==="user"?"white":"#1e293b",padding:"12px 16px",borderRadius:"12px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",fontSize:"14px",lineHeight:"1.6"}}>
                    <div style={{whiteSpace:"pre-wrap"}}>{msg.content}</div>
                    {msg.role==="assistant" && msg.source && <div style={{marginTop:"8px"}}><SourceBadge source={msg.source}/></div>}
                  </div>
                </div>
              ))}
              {loading && (
                <div style={{display:"flex",justifyContent:"flex-start",marginBottom:"16px"}}>
                  <div style={{background:"white",padding:"12px 16px",borderRadius:"12px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",color:"#64748b",fontSize:"14px"}}>
                    {searchWeb?"🔍 Buscando en documentos e internet...":"🔍 Buscando en documentos..."}
                  </div>
                </div>
              )}
              <div ref={messagesEndRef}/>
            </div>

            <div style={{padding:"12px 16px",background:"white",borderTop:"1px solid #e2e8f0"}}>
              <div style={{display:"flex",alignItems:"center",marginBottom:"10px",gap:"10px"}}>
                <label style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontSize:"13px",color:"#475569"}}>
                  <div onClick={() => setSearchWeb(v => !v)} style={{width:"40px",height:"22px",borderRadius:"11px",background:searchWeb?"#3b82f6":"#cbd5e1",position:"relative",transition:"background 0.2s",cursor:"pointer"}}>
                    <div style={{position:"absolute",top:"3px",left:searchWeb?"20px":"3px",width:"16px",height:"16px",borderRadius:"50%",background:"white",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)"}}/>
                  </div>
                  <span>{searchWeb?"🌐 Búsqueda en internet activada":"📁 Solo documentos internos"}</span>
                </label>
                <span style={{fontSize:"11px",color:"#94a3b8"}}>{searchWeb?"Si no hay info en tus documentos, buscará en internet":"Responde solo con tus archivos cargados"}</span>
              </div>
              <div style={{display:"flex",gap:"8px"}}>
                <textarea value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKeyDown} placeholder="Escribe tu pregunta... (Enter para enviar)" rows={2} style={{flex:1,padding:"10px 14px",border:"1px solid #e2e8f0",borderRadius:"8px",resize:"none",fontSize:"14px",outline:"none",fontFamily:"inherit"}}/>
                <button onClick={sendMessage} disabled={loading||!input.trim()} style={{padding:"0 20px",background:loading?"#94a3b8":"#3b82f6",color:"white",border:"none",borderRadius:"8px",cursor:loading?"not-allowed":"pointer",fontWeight:600,fontSize:"14px"}}>
                  {loading?"...":"Enviar"}
                </button>
              </div>
            </div>
          </div>
        )}

        {activeTab==="docs" && (
          <div style={{padding:"20px",overflowY:"auto",flex:1}}>
            <h3 style={{margin:"0 0 16px",color:"#1e293b"}}>📁 Documentos cargados</h3>
            <div style={{background:"white",borderRadius:"10px",padding:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",marginBottom:"20px"}}>
              <div style={{fontWeight:600,marginBottom:"12px",color:"#374151"}}>Subir nuevo documento</div>
              <div style={{display:"flex",gap:"10px",alignItems:"center",flexWrap:"wrap"}}>
                <select value={category} onChange={e => setCategory(e.target.value)} style={{padding:"8px 12px",border:"1px solid #e2e8f0",borderRadius:"6px",fontSize:"13px"}}>
                  {["general","manual","contrato","normativa","financiero","técnico","histórico"].map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <label style={{padding:"8px 16px",background:uploading?"#94a3b8":"#3b82f6",color:"white",borderRadius:"6px",cursor:uploading?"not-allowed":"pointer",fontWeight:600,fontSize:"13px"}}>
                  {uploading?"Subiendo...":"📎 Seleccionar archivo"}
                  <input type="file" accept=".pdf,.docx,.doc,.txt,.md,.csv,.xlsx,.xls" onChange={handleUpload} disabled={uploading} style={{display:"none"}}/>
                </label>
                <span style={{fontSize:"12px",color:"#94a3b8"}}>PDF, Word, Excel, TXT</span>
              </div>
            </div>
            {documents.length===0 ? (
              <div style={{textAlign:"center",color:"#94a3b8",marginTop:"40px"}}>No hay documentos cargados aún.</div>
            ) : (
              documents.map((doc,i) => (
                <div key={i} style={{background:"white",borderRadius:"10px",padding:"14px 16px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",marginBottom:"10px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontWeight:600,color:"#1e293b",fontSize:"14px"}}>📄 {doc.filename}</div>
                    <div style={{fontSize:"12px",color:"#64748b",marginTop:"3px"}}>Categoría: {doc.category} · {doc.size_chars?.toLocaleString()} caracteres · {doc.uploaded?new Date(doc.uploaded).toLocaleDateString("es-EC"):""}</div>
                  </div>
                  <button onClick={() => handleDelete(doc.filename)} style={{padding:"6px 12px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:"6px",cursor:"pointer",fontWeight:600,fontSize:"12px"}}>Eliminar</button>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
